import { Component, OnInit, ViewChild, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';
import { change_passwordModel } from './change_password.model';
import { ButtonComponent } from '../../../button/button.component';
import { FormComponent } from '../../../form/form.component';
import { ServiceStock } from '../../../service-stock.service';
import { HttpResponse } from '@angular/common/http';
import { PasswordComponent } from '../../../password/password.component';

const customCss: string = '';

@Component({
    selector: 'app-change_password',
    templateUrl: './change_password.component.html'
})
export class change_passwordComponent extends FormComponent implements OnInit, AfterViewInit {
    @ViewChild('txtCurrentPass', { static: false }) txtCurrentPass: PasswordComponent;
    @ViewChild('txtNewPass', { static: false }) txtNewPass: PasswordComponent;
    @ViewChild('txtRePass', { static: false }) txtRePass: PasswordComponent;
    @ViewChild('btnSubmit', { static: false }) btnSubmit: ButtonComponent;
    @ViewChild('btnCancel', { static: false }) btnCancel: ButtonComponent;
    @Input('changePasswordType') changePasswordType: string;
    @Output() changePwdPageLink = new EventEmitter<String>();
    skeletonContentLoaded = false;
    async revalidate(): Promise<number> {
        var totalErrors = 0;
        super.beforeRevalidate();
        await Promise.all([
            this.revalidateBasicField('txtCurrentPass'),
            this.revalidateBasicField('txtNewPass'),
            this.revalidateBasicField('txtRePass'),
        ]).then((errorCounts) => {
            errorCounts.forEach((errorCount) => {
                totalErrors += errorCount;
            });
        });
        this.errors = totalErrors;
        super.afterRevalidate();
        return totalErrors;
    }
    constructor(services: ServiceStock) {
        super(services);
        this.value = new change_passwordModel();
        this.componentCode = 'change_password';
    }
    setReadOnly(readOnly) {
        super.setBasicFieldsReadOnly(readOnly);
    }
    async onFormLoad() {
        this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
        this.txtCurrentPass.setFocus(true);
        this.setDependencies();
    }
    setInputs(param: any) {
        let params = this.services.http.mapToJson(param);
        if (params['mode']) {
            this.mode = params['mode'];
        }
    }
    async submitForm(path, apiCode, serviceCode) {
        this.submitData['formName'] = 'change_password';
        await super.submit(path, apiCode, serviceCode);
    }
    getFieldInfo() {
        this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        // this.fileUploadFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        return this.additionalInfo;
    }
    getFieldValue() {
        return this.value;
    }
    setValue(inputValue, inputDesc = undefined) {
        this.setBasicFieldsValue(inputValue, inputDesc);
        this.value = new change_passwordModel();
        this.value.setValue(inputValue);
        this.setDependencies();
        this.passNewValue(this.value);
    }
    ngOnInit() {
        if (this.formCode == undefined) { this.formCode = 'change_password'; }
        if (this.formOnLoadError) { return; }
        setTimeout(() => {
            this.skeletonContentLoaded = true;
        }, 1000);
        var styleElement = document.createElement('style');
        styleElement.type = 'text/css';
        //styleElement.innerHTML = customCss; //commented by Shanmuga Priya - VAPT
	// Safe: sanitized CSS, using textContent instead of innerHTML (no DOM XSS risk)
	//const safeCSS = this.sanitizeCSS(customCss);
	styleElement.textContent = customCss;
        styleElement.id = 'change_password_customCss';
        document.getElementsByTagName('head')[0].appendChild(styleElement);
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        var styleElement = document.getElementById('change_password_customCss');
        styleElement.parentNode.removeChild(styleElement);
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.subsBFldsValueUpdates();
            this.onFormLoad();
            this.checkForHTabOverFlow();
        });
    }
    clearError() {
        super.clearBasicFieldsError();
        super.clearHTabErrors();
        super.clearVTabErrors();
        this.errors = 0;
        this.errorMessage = [];
    }
    onReset() {
        super.resetBasicFields();
        this.clearHTabErrors();
        this.clearVTabErrors();
        this.errors = 0;
        this.errorMessage = [];
        this.additionalInfo = undefined;
        this.dependencyMap.clear();
        this.value = new change_passwordModel();
        this.passNewValue(this.value);
        this.setReadOnly(false);
        this.onFormLoad();
    }
    async btnSubmit_click() {
        let inputMap = new Map();
        var errorCount: number = await this.revalidate();
        document.getElementById('errMsgDiv').innerHTML = "";
        //   this.changePwdPageLink.emit("loginForm");
        if (errorCount == 0) {
            if (this.txtCurrentPass.getFieldValue() == this.txtNewPass.getFieldValue()) {
                document.getElementById('errMsgDiv').innerHTML = "Current Password and New Password should not be same";
            }
            else if (this.txtNewPass.getFieldValue() != this.txtRePass.getFieldValue()) {
                document.getElementById('errMsgDiv').innerHTML = "New Password and Re-enter Password should be same";
            }
            else {
                inputMap.clear();
                inputMap.set('Body.passkey', this.txtCurrentPass.getFieldValue());
                inputMap.set('Body.password1', this.txtNewPass.getFieldValue());
                inputMap.set('Body.password2', this.txtRePass.getFieldValue());
                this.services.http.fetchApi('/auth/changepwd', 'POST', inputMap).subscribe(
                    async (httpResponse: HttpResponse<any>) => {
                        var res = httpResponse.body;
                        var respCode: any = res['respCode'];
                        if (respCode != null && respCode == 0) {
                            // document.getElementById('errMsgDiv').innerHTML = "Your Password Changed Successfully";
                            // if(this.changePasswordType!="modalWindow"){
                            if (this.changePasswordType == "modalWindow" || this.changePasswordType != "modalWindow") {
                                var navPath = ('/login').split('/');
                                navPath = navPath.slice(1);
                                this.services.dataStore.setRouteParams(this.services.routing.currModal, inputMap);
                                if (this.services.routing.currModal > 0) {
                                    var routerOutlets = {};
                                    routerOutlets[this.services.routing.currOutlet] = [navPath[navPath.length - 1], 'popup'];
                                    this.services.router.navigate([{ outlets: routerOutlets }], { skipLocationChange: true });
                                } 
                            // else {
                            //     this.services.router.navigate(navPath);
                            // }
                            else {
                                document.getElementById('errMsgDiv').innerHTML = "Your Password Changed Successfully";
                                setTimeout(() => {
                                    document.getElementById('errMsgDiv').innerHTML = 'Redirecting to login page';
                                }, 2000);
                                setTimeout(() => {
                                    if (this.changePasswordType != "modalWindow")
                                        this.changePwdPageLink.emit("loginForm");
                                    else {
                                        var navPath = ('/login').split('/');
                                        navPath = navPath.slice(1);
                                        this.services.router.navigate(navPath);
                                    }
                                }, 4000);

                            }
                        }
                        }
                        else {
                            //document.getElementById('errMsgDiv').innerHTML = res['errMsg'];
			    //commented by Shanmuga Priya - VAPT
			    const rawMsg = res['errMsg'];
                            const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
                            (document.getElementById('errMsgDiv') as HTMLElement).textContent = plainMsg;
                        }
                    },
                    async (httpError) => {
                        var err = httpError['error']
                        if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
                            if (err['ErrorElementPath'] == 'password2') {
                                this.txtRePass.setError(err['ErrorDescription']);
                            }
                            else if (err['ErrorElementPath'] == 'password1') {
                                this.txtNewPass.setError(err['ErrorDescription']);
                            }
                            else if (err['ErrorElementPath'] == 'passkey') {
                                this.txtCurrentPass.setError(err['ErrorDescription']);
                            }
                        }
                        document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');
                    }
                );
            }
        }
    }
    async btnCancel_click() {
        this.changePwdPageLink.emit("loginForm");
    }
    transalte(text) {
        return this.services.translate.instant(text);
    }
    fieldDependencies = {
    }
}